import { Card, Suit, Rank } from "./Card";

export class Deck {
  private static readonly SUITS: Suit[] = ["♠", "♥", "♦", "♣"];
  private static readonly RANKS: Rank[] = [
    "A", "2", "3", "4", "5", "6", "7", "8", "9", "10", "J", "Q", "K"
  ];

  private cards: Card[] = [];

  constructor() {
    this.createDeck();
  }

  private createDeck(): void {
    this.cards = [];
    for (const suit of Deck.SUITS) {
      for (const rank of Deck.RANKS) {
        this.cards.push(new Card({ suit, rank, faceUp: false }));
      }
    }
    // Validate deck has exactly 52 cards (4 suits × 13 ranks)
    if (this.cards.length !== 52) {
      console.error(`Deck creation error: Expected 52 cards, but created ${this.cards.length} cards`);
    }
  }

  shuffle(): void {
    for (let i = this.cards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.cards[i], this.cards[j]] = [this.cards[j], this.cards[i]];
    }
  }

  deal(): Card | undefined {
    return this.cards.pop();
  }

  isEmpty(): boolean {
    return this.cards.length === 0;
  }

  reset(): void {
    this.createDeck();
  }

  get count(): number {
    return this.cards.length;
  }
}
